export const LAST_ACTIVITY_KEY = "compass.lastActivityAt";
export const IDLE_DEADLINE_KEY = "compass.idleDeadlineAt";
export const INACTIVITY_LOGOUT_KEY = "compass.inactivityLogout";
export const MANUAL_LOGOUT_KEY = "compass.manualLogout";

export const INACTIVITY_LIMIT_MS = 30 * 60 * 1000;
export const GRACE_PERIOD_MS = 5 * 60 * 1000;
export const MAX_IDLE_MS = INACTIVITY_LIMIT_MS + GRACE_PERIOD_MS;

export function readLastActivity(fallback = null) {
  try {
    const raw = window.localStorage.getItem(LAST_ACTIVITY_KEY);
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : fallback;
  } catch {
    return fallback;
  }
}

export function writeLastActivity(ts = Date.now()) {
  try {
    window.localStorage.setItem(LAST_ACTIVITY_KEY, String(ts));
  } catch {
    // ignore storage failures
  }
}

export function clearActivityState() {
  try {
    window.localStorage.removeItem(LAST_ACTIVITY_KEY);
    window.localStorage.removeItem(IDLE_DEADLINE_KEY);
  } catch {
    // ignore storage failures
  }
}

export function clearSessionLogoutFlags() {
  try {
    window.localStorage.removeItem(INACTIVITY_LOGOUT_KEY);
    window.localStorage.removeItem(MANUAL_LOGOUT_KEY);
  } catch {
    // ignore storage failures
  }
}

export function isIdleSessionExpired(now = Date.now()) {
  const lastActivity = readLastActivity(null);

  if (!lastActivity) return false;
  if (lastActivity > now) return false;

  return now - lastActivity >= MAX_IDLE_MS;
}
